import { render, staticRenderFns } from "./MaterialTraceabilityTab.vue?vue&type=template&id=3ecf5b9a&scoped=true&"
import script from "./MaterialTraceabilityTab.vue?vue&type=script&lang=js&"
export * from "./MaterialTraceabilityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf5b9a",
  null
  
)

export default component.exports